import { Link } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function trackForSale(source: string) {
  if (window.gtag) {
    window.gtag('event', 'for_sale_click', { source });
  }
}

export default function ForSaleContentBlock() {
  return (
    <div className="w-full border-2 border-[#DC2626] rounded-2xl overflow-hidden my-8">
      {/* Red header bar */}
      <div className="bg-[#DC2626] px-6 py-3 flex items-center gap-3">
        <div className="w-3 h-3 rounded-full bg-white animate-pulse flex-shrink-0"></div>
        <span className="text-white font-black text-sm tracking-widest uppercase">
          🚨 This Website Is For Sale
        </span>
      </div>

      {/* Content */}
      <div className="bg-white px-6 py-5 flex flex-col md:flex-row items-start md:items-center gap-5">
        <div className="flex-1">
          <p className="text-gray-700 font-semibold text-base mb-3">
            Acquire a fully built, monetization-ready digital asset:
          </p>
          <ul className="space-y-1.5">
            {[
              'Built for SEO traffic — 142 indexed pages across 10 cities',
              'Monetization-ready — affiliate links + ad placements',
              'Full admin dashboard — no coding required',
              'Pre-qualification funnel drives lead revenue',
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-checkbox-circle-fill text-[#DC2626] text-base flex-shrink-0 mt-0.5"></i>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex-shrink-0">
          <Link
            to="/for-sale"
            onClick={() => trackForSale('content_block')}
            className="flex items-center gap-2 bg-[#DC2626] hover:bg-red-700 text-white font-bold px-6 py-3 rounded-xl cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-store-line"></i>
            Own This Website
          </Link>
        </div>
      </div>
    </div>
  );
}
